<ng-container [ngSwitch]="showOpenRegistration$ | async">
  <app-open-registration *ngSwitchCase="true"></app-open-registration>
  <app-registration-list *ngSwitchCase="false"></app-registration-list>
  <div *ngSwitchDefault class="registration-list-route__spinner">
    <se-fe-spinner [seFeDataCenter]="true" [seFeDataSize]="900"></se-fe-spinner>
  </div>
</ng-container>
